import * as React from 'react';
import { bindActionCreators } from 'redux';
import { push } from 'react-router-redux';
import { filter, flow } from 'lodash';
import { connect } from 'react-redux';
import { IAuthState } from '../../../../services/auth/models';
import { actions as authActions, IAuthActions } from '../../../../services/auth/reducer';
import { actions as quoteActions } from '../../../../services/quote/reducer';
import { actions as brandingActions } from '../../../../services/branding/reducer';
import { IQuoteActions, IQuoteState } from '../../../../services/quote/models';
import { IBrandingActions, IBrandingState } from '../../../../services/branding/models';
import Loading from '../../../../components/Loading';
import { withJob } from 'react-jobs';
import { IPolicyApplication } from '../../../../data/api/models';
import { IStore } from '../../../../redux/IStore';
import { SectionTitle } from '../Components/SectionTitle';
import QuoteCard from '../Components/QuoteCard';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';

interface IAccountSummaryProps {
  auth: IAuthState;
  quote: IQuoteState;
  actions: {
    push: (route: string) => void;
    auth: IAuthActions;
    branding: IBrandingActions,
    quote: IQuoteActions;
  };
  branding?: IBrandingState;
  location: any;
}

interface IAccountSummaryState {
  showExpiredQuotes;
}

class QuotesSummary extends React.Component<IAccountSummaryProps, IAccountSummaryState> {

  constructor(props) {
    super(props);

    this.state = {
      showExpiredQuotes: false,
    }
  }

  public renderActiveQuotes() {
    const { auth } = this.props;

    const policyApplications = filter(
      auth.customer.policyApplications,
      (application: IPolicyApplication) => {
        return application.status !== 'renewal' &&
          application.status !== 'renewal invited' &&
          application.status !== 'applied' &&
          application.status !== 'customer lapsed' &&
          application.quoteType !== 'mid term adjustment';
      },
    );

    if ((policyApplications.length < 1)) {
      return (
        <>
          <h2><strong>Your Quotes</strong></h2>
          <p>
            You currently don't have any quotes.
          </p>
        </>
      );
    }

    return (
      <>
        <div>
          {policyApplications.map((quote: IPolicyApplication, index) => {
            return (
              <QuoteCard quote={quote} key={index}/>
            )
          })}
        </div>
      </>
    )
  }

  private handleShowExpiredQuotes = () => {
    const { showExpiredQuotes } = this.state;
    this.setState({ showExpiredQuotes: !showExpiredQuotes })
  }

  private renderExpiredQuotes = () => {
    const { auth } = this.props;
    const { showExpiredQuotes } = this.state;

    const expiredQuotes = filter(
      auth.customer.expiredPolicyApplications,
      (application: IPolicyApplication) => {
        return application.status !== 'renewal' &&
          application.status !== 'renewal invited' &&
          application.status !== 'applied' &&
          application.status !== 'customer lapsed' &&
          application.quoteType !== 'mid term adjustment';
      },
    );

    if (expiredQuotes?.length < 1) {
      return null;
    }

    return (
      <>
        <div className={'section-container'}>
          <div className={'status-indicator'}>
            <SectionTitle text={'Expired quotes'}/>
          </div>
          <div className={'show-button'} onClick={this.handleShowExpiredQuotes}>{
            showExpiredQuotes ? <>HIDE <FaChevronUp/></> : <>SHOW <FaChevronDown/></>}
          </div>
        </div>
        {showExpiredQuotes && (
          <div>
            {expiredQuotes.map((quote: IPolicyApplication, index) => {
              return (
                <QuoteCard quote={quote} key={index}/>
              );
            })}
          </div>
        )}
      </>
    );
  }

  public render() {

    return (
      <div className="page-container">
        {this.renderActiveQuotes()}
        {this.renderExpiredQuotes()}
      </div>
    );
  }
}

export default flow([
  withJob({
    work: (props: IAccountSummaryProps) => {
      const promises = [];

      promises.push(props.actions.auth.reloadCustomer());

      return Promise.all(promises);
    },
    LoadingComponent: (props) => <Loading/>,
    ErrorComponent: ({ error }) => {
      console.error(error);

      return (
        <div>
          {error.message}
        </div>
      );
    },
  }),
  connect(
    (state: IStore) => {
      return {
        auth: state.auth,
        quote: state.quote,
        branding: state.branding,
      };
    },
    (dispatch) => ({
      actions: {
        auth: bindActionCreators({ ...authActions }, dispatch),
        push: bindActionCreators(push, dispatch),
        quote: bindActionCreators({ ...quoteActions }, dispatch),
        branding: bindActionCreators({ ...brandingActions }, dispatch),
      },
    }),
  ),
])(QuotesSummary);
